import React from 'react';
import { DiReact, DiPython, DiJavascript1, DiHtml5, DiCss3 } from "react-icons/di";
import { SiFirebase } from "react-icons/si";
import { BsThreeDots } from "react-icons/bs";
import { GiCornerFlag } from "react-icons/gi";
import Skill from "../../Pages/AboutMe/SkillSection/Abilities/Skill";

const Icons = ({ cls, react = false, python = false, js = false, html = false, css = false, firebase = false, ctf = false }) => {
  const icons = [];

  Object.entries({ react, python, js, html, css, firebase, ctf }).forEach(([key, value]) => {
    if (value) {
      switch (key) {
        case 'react':
          icons.push(<Skill icon={<DiReact />} key={1}/>);
          break;
        case 'python':
          icons.push(<Skill icon={<DiPython />} key={2}/>);
          break;
        case 'js':
          icons.push(<Skill icon={<DiJavascript1 />} key={3}/>);
          break;
        case 'html':
          icons.push(<Skill icon={<DiHtml5 />} key={4}/>);
          break;
        case 'css':
          icons.push(<Skill icon={<DiCss3 />} key={5}/>);
          break;
        case 'firebase':
          icons.push(<Skill icon={<SiFirebase />} key={6}/>);
          break;
        case 'ctf':
          icons.push(<Skill icon={<GiCornerFlag />} key={7}/>);
          break;
        default:
          break;
      }
    }
  });

  return (
    <div className={`icon-container ${cls}`}>
      {icons.length > 0 && icons}
      <Skill icon={<BsThreeDots />} />
    </div>
  );
};

export default Icons;
